export const createArrayBasedOnStartEndPoint = (startPage: number, endPage: number) => {

  if (startPage > endPage) {

    return [];
  
  }

  return Array(endPage - startPage + 1).fill(null).map((_, i) => startPage + i);

};
